import type {Question, QuestionStatus} from '@cp/model';
import {useCallback, useState} from 'react';
import fetchQuestionForReviewDoc from '../../api/question/fetchQuestionForReviewDoc';

export interface FetchQuestionForReviewVariables {
  moduleId: string;
  topics?: string[];
  difficulty?: number;
  status?: QuestionStatus;
  skip?: number;
}

export function useFetchQuestionForReview() {
  const [question, setQuestion] = useState<Question | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const fetchQuestionForReview = useCallback(async (variables: FetchQuestionForReviewVariables) => {
    setLoading(true);
    setError(undefined);
    try {
      const q = await fetchQuestionForReviewDoc(variables);
      setQuestion(q);
      return q;
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    fetchQuestionForReview,
    question,
    loading,
    error,
  };
}
